var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 페이지를 찾을 수 없습니다. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }